import type { AmenityItem } from '../types/amenity-icon.type';

const amenities: AmenityItem[] = [
	{ id: 1, label: 'Heat', icon: 'am_heat' },
	{ id: 2, label: 'AC', icon: 'am_ac' },
	{ id: 3, label: 'WiFi', icon: 'am_wifi' },
	{ id: 4, label: 'Restrooms', icon: 'am_restrooms' },
	{ id: 5, label: 'Drinking Water', icon: 'am_drinking' },
	{ id: 6, label: 'Parking', icon: 'am_parking' },
	{ id: 7, label: 'Concessions', icon: 'am_concessions' },
	{ id: 8, label: 'Shelters', icon: 'am_shelters' },
	{ id: 9, label: 'Portable Restrooms', icon: 'am_portableRestrooms' },
	{ id: 10, label: 'Lights', icon: 'am_lights' },
	{ id: 11, label: 'Locker Room', icon: 'am_lockerRoom' },
	{ id: 12, label: 'Paid Parking', icon: 'am_paidParking' },
	{ id: 13, label: 'Accessible', icon: 'am_accessible' },
];

export const getAmenitiesByIds = (ids: number[]): AmenityItem[] => {
	return amenities.filter(amenity => ids.includes(amenity.id));
};

export default amenities;
